<div class="photo-buttons" *ngIf="!image; else addPhotoTemplate">
	<ion-button fill="clear" class="left" (click)="addPhotoFromCamera()">
		<ion-icon slot="start" src="./assets/icon/image.svg"></ion-icon>
		{{ 'SHARED_TEXT.MEDIA.TAKE_PHOTO' | translate }}
	</ion-button>

	<span>Or</span>

	<ion-button fill="clear" class="right" (click)="addPhotoFromLibrary()">
		<ion-icon slot="start" src="./assets/icon/folder.svg"></ion-icon>
		{{ 'SHARED_TEXT.MEDIA.CHOOSE_PHOTO' | translate }}
	</ion-button>
</div>

<ng-template #addPhotoTemplate>
	<div class="image-view">
		<div class="close-btn">
			<ion-button class="edit-btn" fill="clear" (click)="editPhoto.emit()">
				<ion-icon name="pencil-outline" slot="icon-only"></ion-icon>
			</ion-button>
			<ion-button fill="clear" (click)="photoRemoved.emit()">
				<ion-icon name="close" slot="icon-only"></ion-icon>
			</ion-button>
		</div>
		<ion-img *ngIf="image" [src]="image"></ion-img>
	</div>
</ng-template>
